module.exports = __webpack_public_path__ + "img/emoji-chat@3x.806a3c1.png";